/**
 * Hook for managing QZ Tray printer connection
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
// @ts-ignore
import qz from 'qz-tray';
import $ from 'jquery';
import { useSelector, useDispatch } from 'react-redux';
import { selectUserPreferences, setUserPreference } from '../../redux/packing';
export var usePrinterConnection = function () {
    var dispatch = useDispatch();
    var userPreferences = useSelector(selectUserPreferences);
    var _a = useState(false), isConnectionActive = _a[0], setIsConnectionActive = _a[1];
    var _b = useState([]), printers = _b[0], setPrinters = _b[1];
    // Connect to QZ Tray
    var connectPrinter = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 4, , 5]);
                    if (!qz || !qz.websocket || !qz.printers) {
                        console.error('qz library is not properly initialized or available.');
                        return [2 /*return*/];
                    }
                    // Set certificate
                    qz.security.setCertificatePromise(function (resolve, reject) {
                        $.ajax(process.env.REACT_APP_API_BASE_URL + "/qz-tray/digital-certificate.txt?t=" + Date.now()).then(function (data) { return resolve(data); }, function (err) { return reject(err); });
                    });
                    if (!!qz.websocket.isActive()) return [3 /*break*/, 2];
                    return [4 /*yield*/, qz.websocket
                            .connect({
                            retries: 5,
                            delay: 1
                        })
                            .then(function () {
                            setIsConnectionActive(true);
                            console.log('QZ Tray Connection established!', qz.websocket.getConnectionInfo());
                        })
                            .catch(function (error) {
                            setIsConnectionActive(false);
                            console.log('QZ Tray connection error:', error);
                        })];
                case 1:
                    _a.sent();
                    qz.security.setSignaturePromise(function (toSign) {
                        return function (resolve, reject) {
                            return __awaiter(this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    fetch(process.env.REACT_APP_API_BASE_URL + "/apps/qzSign?message=" + toSign, {
                                        headers: { 'Content-Type': 'text/plain' }
                                    })
                                        .then(function (data) {
                                        data.ok ? resolve(data.text()) : reject(data.text());
                                    })
                                        .catch(function (err) {
                                        console.error('Error in QZ Tray signing message:', err);
                                    });
                                    return [2 /*return*/];
                                });
                            });
                        };
                    });
                    return [3 /*break*/, 3];
                case 2:
                    setIsConnectionActive(true);
                    console.log('QZ tray connection is already established', qz.websocket.getConnectionInfo());
                    _a.label = 3;
                case 3: return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    setIsConnectionActive(false);
                    console.error('Error connecting to QZ Tray:', error_1);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); }, []);
    // Disconnect from QZ Tray
    var disconnectPrinter = useCallback(function () {
        var _a;
        if (qz && ((_a = qz === null || qz === void 0 ? void 0 : qz.websocket) === null || _a === void 0 ? void 0 : _a.isActive())) {
            qz.websocket.disconnect();
            setIsConnectionActive(false);
        }
    }, []);
    // Find available printers
    var findPrinters = useCallback(function () { return __awaiter(void 0, void 0, Promise, function () {
        var foundPrinters, error_2;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 5, , 6]);
                    if (!!((_a = qz === null || qz === void 0 ? void 0 : qz.websocket) === null || _a === void 0 ? void 0 : _a.isActive())) return [3 /*break*/, 2];
                    return [4 /*yield*/, connectPrinter()];
                case 1:
                    _c.sent();
                    _c.label = 2;
                case 2:
                    if (!((_b = qz === null || qz === void 0 ? void 0 : qz.websocket) === null || _b === void 0 ? void 0 : _b.isActive())) return [3 /*break*/, 4];
                    return [4 /*yield*/, qz.printers.find()];
                case 3:
                    foundPrinters = _c.sent();
                    setPrinters(foundPrinters || []);
                    return [2 /*return*/, foundPrinters || []];
                case 4: return [2 /*return*/, []];
                case 5:
                    error_2 = _c.sent();
                    console.error('Error finding printers:', error_2);
                    return [2 /*return*/, []];
                case 6: return [2 /*return*/];
            }
        });
    }); }, [connectPrinter]);
    // Print a label
    var printLabel = useCallback(function (labelUrl, printerType) {
        if (printerType === void 0) { printerType = 'main'; }
        return __awaiter(void 0, void 0, void 0, function () {
            var printerKey, printerName, config_1, moquiSessionToken, response, blob, reader_1, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        printerKey = "qz.printer." + printerType + ".active";
                        printerName = userPreferences[printerKey];
                        if (!qz || !qz.websocket || !qz.printers || !printerName) {
                            console.error('qz library not initialized or no printer selected');
                            return [2 /*return*/];
                        }
                        if (!!qz.websocket.isActive()) return [3 /*break*/, 2];
                        return [4 /*yield*/, connectPrinter()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!qz.websocket.isActive()) return [3 /*break*/, 4];
                        config_1 = qz.configs.create(printerName);
                        moquiSessionToken = localStorage.getItem('moquiSessionToken');
                        return [4 /*yield*/, axios.get(labelUrl + "&moquiSessionToken=" + moquiSessionToken, {
                                responseType: 'arraybuffer',
                                headers: {
                                    'Content-Type': 'application/json',
                                    Accept: 'application/pdf'
                                }
                            })];
                    case 3:
                        response = _a.sent();
                        if (response.status !== 200) {
                            throw new Error("HTTP error! Status: " + response.status);
                        }
                        blob = new Blob([response.data]);
                        reader_1 = new FileReader();
                        reader_1.onloadend = function () {
                            var result = reader_1.result;
                            if (result) {
                                var base64data = result.split(',')[1];
                                var printDataObj = {
                                    type: 'pixel',
                                    format: 'pdf',
                                    flavor: 'base64',
                                    data: base64data
                                };
                                qz.print(config_1, [printDataObj])
                                    .then(function () {
                                    console.log('Successfully printed');
                                })
                                    .catch(function (err) {
                                    console.error('Print error =>', err);
                                });
                            }
                            else {
                                console.error('Reader result is null or undefined');
                            }
                        };
                        reader_1.readAsDataURL(blob);
                        _a.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        error_3 = _a.sent();
                        console.error('Error printing label:', error_3);
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    }, [userPreferences, connectPrinter]);
    // Set active printer
    var setActivePrinter = useCallback(function (printerType, printerName) {
        var preferenceKey = "qz.printer." + printerType + ".active";
        dispatch(setUserPreference({
            preferenceKey: preferenceKey,
            preferenceValue: printerName
        }));
    }, [dispatch]);
    // Get active printer
    var getActivePrinter = useCallback(function (printerType) {
        var printerKey = "qz.printer." + printerType + ".active";
        return userPreferences[printerKey];
    }, [userPreferences]);
    // Connect on mount
    useEffect(function () {
        connectPrinter();
        return function () {
            disconnectPrinter();
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    return {
        isConnectionActive: isConnectionActive,
        printers: printers,
        connectPrinter: connectPrinter,
        disconnectPrinter: disconnectPrinter,
        findPrinters: findPrinters,
        printLabel: printLabel,
        setActivePrinter: setActivePrinter,
        getActivePrinter: getActivePrinter
    };
};
export default usePrinterConnection;
